export default "__VITE_ASSET__lI6iQ9wh__"